import { Carwash, OperatingHours } from '../types/CarwashType';

export function formatDistance(distanceKm: number): string {
  if (distanceKm < 1) {
    return `${Math.round(distanceKm * 1000)} m`;
  }
  return `${distanceKm.toFixed(1)} km`;
}

export function formatAddress(carwash: Carwash): string {
  const parts = [carwash.street, carwash.number, carwash.neighborhood, carwash.city];
  return parts.filter(Boolean).join(', ');
}

export function buildDirectionsUrl(carwash: Carwash): string {
  const destination = `${carwash.latitude},${carwash.longitude}`;
  return `https://www.google.com/maps/dir/?api=1&destination=${destination}`;
}

export function buildWazeUrl(carwash: Carwash): string {
  return `https://waze.com/ul?ll=${carwash.latitude},${carwash.longitude}&navigate=yes`;
}

export function formatOperatingHours(hours: OperatingHours[]): string {
  const today = new Date().getDay();
  const todayHours = hours.find((h) => h.day_of_week === today);

  if (!todayHours) return 'Horário não disponível';
  if (!todayHours.is_open) return 'Fechado hoje';

  return `Hoje: ${todayHours.open_time} – ${todayHours.close_time}`;
}

export function isOpenNow(hours: OperatingHours[]): boolean {
  const now = new Date();
  const today = now.getDay();
  const todayHours = hours.find((h) => h.day_of_week === today);

  if (!todayHours || !todayHours.is_open) return false;

  const [openH, openM] = todayHours.open_time.split(':').map(Number);
  const [closeH, closeM] = todayHours.close_time.split(':').map(Number);
  const currentMinutes = now.getHours() * 60 + now.getMinutes();
  const openMinutes = openH * 60 + openM;
  const closeMinutes = closeH * 60 + closeM;

  return currentMinutes >= openMinutes && currentMinutes <= closeMinutes;
}
